/* eslint-disable no-unused-vars */

export const imgDomain = 'https://gymoo-private.oss-cn-shenzhen.aliyuncs.com/';